import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { CompanyCodesNames, CompanyNames } from '../../companies';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-companies-filter',
  templateUrl: './companies-filter.component.html',
  styleUrls: ['./companies-filter.component.scss'],
  standalone: false,
})
export class CompaniesFilterComponent implements OnInit {
  @Input() filter;

  constructor() {}

  ngOnInit() {}

  public onChangeSelectedCompany(companySelected: CompanyNames): void {
    this.filter.companySelected = companySelected;
  }

  public onChangeSelectedCode(codeSelected: CompanyCodesNames): void {
    this.filter.codeSelected = codeSelected;
  }

  public onApplyFilter(): void {
    this.filter.onApplyFilter();
  }

  public onResetFilter(): void {
    this.filter.onResetFilter();
  }
}
